import request from '@/utils/request'

const prefix = '/api/v1/back'

/**
 * 文件上传
 * @param {*} params
 */
export const fileUpload = (params) => {
  return request({
    url: `${prefix}/upload/file`,
    method: 'post',
    data: params,
  })
}
// **
//  * 文件上传
//  * @param {*} params
//  *
export const fileUploadvideo = (params) => {
  return request({
    url: `${prefix}/upload/file`,
    method: 'post',
    data: params,
  })
}


/**
 * 登录日志：列表
 * @param {*} query
 */
export const loginlist = (query) => {
  return request({
    url: `${prefix}/admin/login/list`,
    method: 'get',
    params: query
  })
}

/**
 * 用户问题反馈 查询（列表）
 * @param {*} query
 */
export const feedbacklist = (query) => {
  return request({
    url: `${prefix}/member/contact/list`,
    method: 'get',
    params: query
  })
}


/**
 * 订单完成任务（查询列表）
 * @param {*} query
 */
export const doneTasklist = (query) => {
  return request({
    url: `${prefix}/member/order/doneTask/list`,
    method: 'get',
    params: query
  })
}


/**
 * 订单完成任务（修改）
 * @param {*} query
 */
 export const editorderdoneTask = (query) => {
  return request({
    url: `${prefix}/member/order/doneTask`,
    method: 'put',
    data: query
  })
}


/**
 * 订单完成任务（删除）
 * @param {*} query
 */
 export const deleteorderdoneTask = (query) => {
  return request({
    url: `${prefix}/member/order/doneTask`,
    method: 'delete',
    data: query
  })
}
/**
 * 运费模板（查询列表）
 * @param {*} query
 */
export const expressTemplateList = (query) => {
  return request({
    url: `${prefix}/express/expressTemplate/list`,
    method: 'get',
    params: query
  })
}
/**
 * 运费模板（创建）
 * @param {*} params
 */
export const expressTemplate = (params) => {
  return request({
    url: `${prefix}/express/expressTemplate`,
    method: 'post',
    data: params,
  })
}
/**
 * 运费模板（删除）
 * @param {*} query
 */
export const expressTemplateDelte = (query) => {
  return request({
    url: `${prefix}/express/expressTemplate`,
    method: 'delete',
    data: query
  })
}
/**
 * 运费模板修改
 * @param {*} query
 */
export const expressTemplateUpate = (query) => {
  return request({
    url: `${prefix}/express/expressTemplate`,
    method: 'put',
    data: query
  })
}
/**
 * 运费模板（详情）
 * @param {*} query
 */
export const expressTemplateDetail = (query) => {
  return request({
    url: `${prefix}/express/expressTemplate`,
    method: 'get',
    params: query
  })
}



